import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { UsagePage } from '@/features/admin/usage/usage-page';
import { asPeriod, DEFAULT_PERIOD, type UsagePeriod } from '@/features/admin/usage/usage-model';
import { ConsoleShell } from '@/features/shell/console-shell';

/**
 * Entrée « Usage et coûts » (porting README #88). La période vit dans l'URL (`?period=30`) ; celle
 * par défaut, 365 jours comme le backend, ne s'écrit pas.
 */
export const Route = createFileRoute('/$tenant/usage')({
  validateSearch: (search: Record<string, unknown>): { period?: UsagePeriod } => {
    const period = asPeriod(search['period']);
    return period === DEFAULT_PERIOD ? {} : { period };
  },
  component: UsageRoute,
});

function UsageRoute() {
  const { tenant } = Route.useParams();
  const { period = DEFAULT_PERIOD } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const { t } = useTranslation();
  return (
    <ConsoleShell tenantId={tenant} activeItem="usage" crumbs={[{ label: t('nav.items.usage') }]}>
      <UsagePage
        tenantId={tenant}
        period={period}
        onPeriodChange={(next) =>
          void navigate({ search: next === DEFAULT_PERIOD ? {} : { period: next }, replace: true })
        }
      />
    </ConsoleShell>
  );
}
